<template>
  <div style="height: 100%;">
      <the-app-bar class="hidden-sm-and-down"/>
      <the-drawer/>
    <v-main style="height: 100%;">
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-main>
    <the-bottom-navigation class="hidden-md-and-up"/>
  </div>
</template>

<script>
import TheAppBar from '@/components/TheAppBar'
import TheDrawer from '@/components/TheDrawer'
import TheBottomNavigation from '@/components/core/TheBottomNavigation'

export default {
  name: 'AppLayout',
  components: {
    TheAppBar,
    TheDrawer,
    TheBottomNavigation
  }
}
</script>
